import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Card from "../components/Card.jsx";
import ConnectionForm from "../components/ConnectionForm.jsx";
import { connectionApi } from "../../api/connectionApi";
import { getApiError } from "../../api/client";
import { PlugZap, Save } from "lucide-react";
import "../styles/codebase.css";

export default function ConnectionEditPage() {
  const { id } = useParams();
  const nav = useNavigate();

  const [row, setRow] = useState(null);
  const [err, setErr] = useState("");
  const [saving, setSaving] = useState(false);
  const [testing, setTesting] = useState(false);

  const load = async () => {
    setErr("");
    try {
      const r = await connectionApi.get(id);
      setRow(r.data);
    } catch (e) {
      setErr(getApiError(e));
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const submit = async (payload) => {
    setErr("");
    setSaving(true);
    try {
      await connectionApi.update(id, payload);
      nav("/codebase/connections");
    } catch (e) {
      setErr(getApiError(e));
    } finally {
      setSaving(false);
    }
  };

  const testSaved = async () => {
    if (!id) return;
    setErr("");
    setTesting(true);
    try {
      const res = await connectionApi.test(id);
      const ok = !!res.data?.ok;
      const detail = res.data?.detail || "";
      const meta = res.data?.meta ? JSON.stringify(res.data.meta, null, 2) : "";
      alert(`${ok ? "✅" : "❌"} ${detail}${meta ? `\n\nMeta:\n${meta}` : ""}`);
    } catch (e) {
      setErr(getApiError(e));
    } finally {
      setTesting(false);
    }
  };

  const triggerSave = () => {
    const form = document.getElementById("connection-form");
    if (!form) return;
    if (typeof form.requestSubmit === "function") {
      form.requestSubmit();
      return;
    }
    form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
  };

  return (
    <div className="cb-page">
      <div className="page-head">
        <div>
          <h2>Edit Connection</h2>
          <div className="muted">Secrets: enter new value only if you want to update</div>
        </div>

        <div className="page-actions">
          <Link className="btn ghost" to="/codebase/connections">
            Back
          </Link>

          <button className="btn" onClick={testSaved} disabled={testing || !row}>
            <PlugZap size={16} /> {testing ? "Testing…" : "Test Saved"}
          </button>

          <button className="btn primary" onClick={triggerSave} disabled={saving || !row}>
            <Save size={16} /> {saving ? "Saving…" : "Save"}
          </button>
        </div>
      </div>

      {err && <div className="error">{err}</div>}

      <Card title="Connection details">
        {!row ? (
          <div className="muted">Loading…</div>
        ) : (
          <ConnectionForm
            formId="connection-form"
            initial={row}
            onSubmit={submit}
            submitting={saving}
            submitLabel="Save"
          />
        )}
      </Card>
    </div>
  );
}
